/// data preprocessor
import { local, select } from 'd3';
import {assert_key, getLineColor, assert_key_hier, 
    getContinuousVariableCategory,binningContinuousVariable,getDecimal } from './index';
import {getRawDataURL} from '../service/dataService';
import {Tag, Progress, Col} from "antd";
import React from 'react';
import { AnyAaaaRecord } from 'dns';
function extract_task_list(data:any){
    let flag = assert_key(data, ["TaskNames"]);
    if(flag){
        return data["TaskNames"];

    }else{
        return [];
    }
}
function verify_task_id(data:any, task_id:any){
    if(task_id){
        let task_list = extract_task_list(data);
        let new_task_id = task_id - 1;
        if(new_task_id >= 0 && new_task_id <task_list.length){
            let task_name = task_list[new_task_id];
            if(Object.keys(data).indexOf(task_name)>=0){
                return {
                    "success": true,
                    "task_name": task_name
                }
            }
        }
    }
    return {"success": false};
}
function extract_dataset_list(data:any, task_id:any){
    let results = verify_task_id(data, task_id);
    if(results["success"]){
        let task_name = results["task_name"];
        let subdata = data[task_name];
        let flag = assert_key(subdata, ["DatasetNames"]);
        if(flag){
            return subdata["DatasetNames"];
        }
    }
    return [];
    
}
function extract_explore_dataset_list(data:any){
    let flag = assert_key(data, ["DatasetNames"]);
    if(flag){
        return data["DatasetNames"];
    }
    return [];
    
}
function extract_api_list(data:any, task_id:any){
    let results = verify_task_id(data, task_id);
    if(results["success"]){
        let task_name = results["task_name"];
        let subdata = data[task_name];
        let flag = assert_key(subdata, ["APINames"]);
        if(flag){
            return subdata["APINames"];
        }
    }
    return [];
}
function extract_value_from_data(data:any, key:any, dataset_name:any, api_name:any, decimal:number=-1){
    // return {"year", "acc"}
    let flag = assert_key(data, [key]);
    if(flag){
        let accuracy_table = data[key];
        let filtered_results = accuracy_table.filter((d:any)=>{
            let flag2 = assert_key(d, ["Year", "value","API", "Dataset"]);
            if(flag2){
                if(d["API"] == api_name && d["Dataset"] == dataset_name){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        })
        let sorted_results = filtered_results.sort((a:any, b:any)=>{
            return a["Year"] < b["Year"];
        })
        let year = sorted_results.map((d:any)=>{
            return d["Year"]
        })
        let value = sorted_results.map((d:any)=>{
            if(decimal>=1){
                return parseFloat(d["value"].toFixed(decimal))
            }else{
                return d["value"];
            }
        })
        let return_obj = {
            "year": year,
            "value": value
        }
        return return_obj;
    }else{
        return {};
    }
}
function extract_fairness_from_data(data:any, key:any, dataset_name:any, api_name:any){
    // return {"year", "acc"}
    let flag = assert_key(data, [key]);
    if(flag){
        let accuracy_table = data[key];
        let filtered_results = accuracy_table.filter((d:any)=>{
            let flag2 = assert_key(d, ["Year", "value","API", "Dataset", "Subgroup"]);
            if(flag2){
                if(d["API"] == api_name && d["Dataset"] == dataset_name){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        })
        let subgroup_list = Array.from(new Set(filtered_results.map((d:any)=>{
            return d["Subgroup"];
        })));
        let year_list:any = Array.from(new Set(filtered_results.map((d:any)=>{
            return d["Year"];
        })));
        let sorted_year_list = year_list.sort((a:any, b:any)=>{
            return a < b;
        })
        let data_dict:any = {};
        for(let i = 0; i<filtered_results.length; i++){
            let item = filtered_results[i];
            let year = ""+item["Year"];
            let subgroup = item["Subgroup"];
            let subgroup_index = subgroup_list.indexOf(subgroup);
            //console.log("i", i, "subgroup_index", subgroup_index);
            if(subgroup_index<0 || subgroup_index>=subgroup_list.length){
                console.log("Not found subgroup. ", subgroup);
                continue;
            }
            if(Object.keys(data_dict).indexOf(year)<0){
                data_dict[year] = [];
                for(let i = 0; i<subgroup_list.length; i++){
                    data_dict[year].push(0);
                }
            }
            data_dict[year][subgroup_index] = item["value"];
            //console.log("data_dict", JSON.parse(JSON.stringify(data_dict)), "item", item);
            
        }
        //console.log("data_dict", data_dict, "filtered_results", filtered_results);
        let x_axis_data = subgroup_list;
        let y_series_data = [];
        for(let i = 0; i<sorted_year_list.length; i++){
            let local_year = sorted_year_list[i];
            let local_pkg = {
                name: local_year,
                type: 'bar',
                data: data_dict[local_year]
            }
            y_series_data.push(local_pkg);
        }
        /// Construct data
        // {"x_axis_data", "y_series_data"}
        let return_obj = {
            "x_axis_data": x_axis_data,
            "y_series_data": y_series_data
        }
        if(x_axis_data.length == 0 || y_series_data.length == 0){
            return {};
        } 
        return return_obj;
    }else{
        return {};
    }
}
function convert_package_to_graph(pkg:any){
    let decimal = getDecimal();
    let flag = assert_key(pkg, ["year","value"]);
    if(!flag){
        return {};
    }
    let yearlist = pkg["year"];
    let valuelist = pkg["value"];
    let nodes:any = [];
    let links:any = [];

    for(let i = 0; i<yearlist.length; i++){
        let year = yearlist[i];
        let value = valuelist[i];
        let year_array = year.split("->");
        if(year_array.length!=2)continue;
        year_array.forEach((d:any)=>{
            if(nodes.indexOf(d)>=0){
                
            }else{
                nodes.push(d);
            }
        })
        links.push({
            "source": year_array[0],
            "target": year_array[1],
            "value": value.toFixed(decimal),
            "label": {
                "show": true,
                "formatter": (d:any)=>d["value"]
              },
            "lineStyle":{
                "width": 6,
                "color": getLineColor(value)
            }
        })
    }
    nodes.sort((a:any,b:any)=>{
        return a<b;
    })
    let new_nodes:any = [];
    let nodes_length = nodes.length;
    if(nodes.length <= 0){
        return {};
    }
    let start_angle = -90;
    let step_angle = 360 / nodes_length;
    let radius = 10;
    for(let i = 0; i<nodes_length;i++){
        let x = radius * Math.cos(start_angle / 180 * Math.PI);
        let y = radius * Math.sin(start_angle / 180 * Math.PI);
        new_nodes.push({
            "name": nodes[i],
            "x": x,
            "y": y,
            "itemStyle": {
                color: "#5470C6"
              }
        })
        start_angle = start_angle + step_angle;
    }
    return {
        "nodes": new_nodes,
        "links": links
    }
}
function extract_pcp_data_from_package(explore_meta_data:any, selected_dataset_name:any, selected_api_name:any){
    if(assert_key(explore_meta_data, [selected_dataset_name])){
        let dataset_pkg = explore_meta_data[selected_dataset_name];
        let year_list = Object.keys(dataset_pkg);
        let axis_spec = year_list.map((d:any, index:any)=>{
            return {
                "dim": index, 
                "name": d
            }
        })
        let series_data = [];
        let reverted_pkg:any = {};
        let temp_series_data = [];
        for(let i = 0; i<year_list.length; i++){
            let specific_year = year_list[i];
            if(!assert_key(dataset_pkg, [specific_year])){
                continue;
            }
            for(let j = 0; j<dataset_pkg[specific_year].length; j++){
                let item = dataset_pkg[specific_year][j];
                let item_spec = [
                    {"n": "selected_id"}, 
                    {"n":selected_api_name, 
                    "c":[
                        {"n":"Confidence"}
                    ]}
                ];
                let flag1 = assert_key_hier(item, item_spec);
                if(flag1){
                    let selected_id = item["selected_id"];
                    let confidence = item[selected_api_name]["Confidence"];
                    let temp_data_pkg = {
                        "selected_id": selected_id,
                        "confidence": confidence,
                        "year": specific_year
                    }
                    temp_series_data.push(temp_data_pkg);
                }
            }
        }
        temp_series_data.forEach((d:any)=>{
            reverted_pkg[d["selected_id"]] = {}
        })
        temp_series_data.forEach((d:any)=>{
            reverted_pkg[d["selected_id"]][d["year"]] = d["confidence"]
        })


        let item_list = Object.keys(reverted_pkg);
        for(let i = 0; i<item_list.length; i++){
            let item_key = item_list[i];
            let data_pkg = reverted_pkg[item_key];
            let new_data_pkg = [];
            if(assert_key(data_pkg, year_list)){
                for(let j = 0; j<year_list.length; j++){
                    let specific_year = year_list[j];
                    new_data_pkg.push(data_pkg[specific_year]);
                }
                series_data.push(new_data_pkg);
            }

        }
        if(axis_spec.length > 0 && series_data.length > 0){
            return {
                "axis_spec": axis_spec,
                "series_data": series_data
            }
        }else{
            return {};
        }
    }else{
        return {};
    }
}
function remove_duplicate_elements(a:any){
    var l = new Set(a);
    return Array.from(l);
}   
function calculate_mean_of_array(arr:any){
    if(arr.length>0){
        var sum = 0;
        arr.forEach((num:any) => { sum += num });
        let average:any = sum / arr.length;
        return average;
    }else{
        return 0;
    }
    
}
function extract_ps_data_from_package(explore_meta_data:any, selected_dataset_name:any, selected_api_name:any, selected_task_name:any){
    if(assert_key(explore_meta_data, [selected_dataset_name])){
        let ps_name = "PS_"+selected_api_name+"_"+selected_dataset_name;
        let dataset_pkg = explore_meta_data[selected_dataset_name];
        let year_list = Object.keys(dataset_pkg);
        let axis_spec = year_list.map((d:any, index:any)=>{
            return {
                "dim": index, 
                "name": d
            }
        })
        let series_data = [];
        let reverted_pkg:any = {};
        let temp_series_data = [];
        for(let i = 0; i<year_list.length; i++){
            let specific_year = year_list[i];
            if(!assert_key(dataset_pkg, [specific_year])){
                continue;
            }
            for(let j = 0; j<dataset_pkg[specific_year].length; j++){
                let item = dataset_pkg[specific_year][j];
                let predicted_label_key = "OriginalPredictedLabel";
                if(selected_task_name == "Facial Emotion Recogntion"){
                    predicted_label_key = "PredictedLabel";
                }

                let item_spec = [
                    {"n": "selected_id"}, 
                    {"n":selected_api_name, 
                    "c":[
                        {"n":"Confidence"},
                        {"n":"TrueLabel"},
                        {"n":"ImageName"},
                        {"n":predicted_label_key}
                    ]}
                ];
                let flag1 = assert_key_hier(item, item_spec, true, "ps data");
                if(flag1){
                    let selected_id = item["selected_id"];
                    let confidence = item[selected_api_name]["Confidence"];
                    let predicted_label_list:any = [];
                    let true_label = "";
                    if(selected_task_name == "Image Tagging"){
                        let true_label_list = item[selected_api_name]["TrueLabel"].map((d:any)=>{
                            if(assert_key(d, ["transcription"])){
                                return d["transcription"]
                            }else{
                                return "";
                            }
                        });
                        let unique_true_label_list = remove_duplicate_elements(true_label_list);
                        true_label = unique_true_label_list.join(", ")
                        predicted_label_list = item[selected_api_name][predicted_label_key].filter((d:any)=>{
                            if(assert_key(d, ["transcription", "confidence"])){
                                return true;
                            }else{
                                return false;
                            }
                        }).sort((a:any, b:any)=>{
                            return b["confidence"] - a["confidence"]; 
                        })
                    }else{
                        true_label = item[selected_api_name]["TrueLabel"];
                        predicted_label_list = [{
                            "transcription": item[selected_api_name][predicted_label_key],
                            "confidence": parseFloat(confidence)
                        }];
                    }
                    
                    
                    let image_name = item[selected_api_name]["ImageName"];
                    

                    let temp_data_pkg = {
                        "selected_id": selected_id,
                        "confidence": confidence,
                        "year": specific_year,
                        "image_name": image_name,
                        "true_label": true_label,
                        "predicted_label_list": predicted_label_list
                    }
                    temp_series_data.push(temp_data_pkg);
                }
            }
        }
        temp_series_data.forEach((d:any)=>{
            reverted_pkg[d["selected_id"]] = {}
        })
        temp_series_data.forEach((d:any)=>{
            reverted_pkg[d["selected_id"]][d["year"]] = parseFloat(d["confidence"]);
            reverted_pkg[d["selected_id"]]["others"] = d; // Overlapping!
            reverted_pkg[d["selected_id"]]["others_"+d["year"]] = d; 
        })


        let item_list = Object.keys(reverted_pkg);
        for(let i = 0; i<item_list.length; i++){
            let item_key = item_list[i];
            let data_pkg = reverted_pkg[item_key];
            let new_data_pkg:any = {};
            if(assert_key(data_pkg, year_list)){
                // Additional Attributes
                new_data_pkg["image_name"] = data_pkg["others"]["image_name"];
                new_data_pkg["true_label"] = data_pkg["others"]["true_label"];
                for(let j = 0; j<year_list.length; j++){
                    let specific_year = year_list[j];
                    new_data_pkg[specific_year] = data_pkg[specific_year];
                    new_data_pkg["Number_"+specific_year] = data_pkg[specific_year];
                    //new_data_pkg.push(data_pkg[specific_year]);
                    new_data_pkg["predicted_label_list_"+specific_year] = data_pkg["others_"+specific_year]["predicted_label_list"];

                }
                series_data.push(new_data_pkg);
            }
        }
        // Convert continuous variable to discrete variable.
        let Confidence_list: any = [];
        let Confidence_range_list:any = [];
        for(let i = 0; i<year_list.length;i++){
            Confidence_list.push([]);
            Confidence_range_list.push([]);
        }

        for(let i = 0; i<series_data.length;i++){
            let data_json = series_data[i];
            for(let j = 0 ;j<year_list.length;j++){
                let local_year = year_list[j];
                Confidence_list[j].push(data_json[local_year])
            }
        }

        // Individual confidence range
        /*
        for(let i = 0; i<Confidence_list.length; i++){
            Confidence_range_list[i] = binningContinuousVariable(Confidence_list[i]);
        }
        for(let i = 0; i<series_data.length;i++){
            let data_json = series_data[i];
            for(let j = 0; j<year_list.length; j++){
                let local_year = year_list[j];
                data_json[local_year] = getContinuousVariableCategory(data_json[local_year], Confidence_range_list[j]);
            }
        }
        */

        // Combined confidence range
        /*
        let total_Confidence_list:any = [];
        for(let i = 0; i<Confidence_list.length; i++){
            total_Confidence_list = total_Confidence_list.concat(Confidence_list[i])
        }
        let total_confidence_range = binningContinuousVariable(total_Confidence_list);

        for(let i = 0; i<Confidence_list.length; i++){
            Confidence_range_list[i] = total_confidence_range
        }
        for(let i = 0; i<series_data.length;i++){
            let data_json = series_data[i];
            for(let j = 0; j<year_list.length; j++){
                let local_year = year_list[j];
                data_json[local_year] = getContinuousVariableCategory(data_json[local_year], Confidence_range_list[j]);
            }
        }*/

        // Specificed range list:
        let total_confidence_range = [
            {"start": 0, "end": 0.2, "name":"[0,0.2]"},
            {"start": 0.2, "end": 0.4, "name":"[0.2,0.4]"},
            {"start": 0.4, "end": 0.6, "name":"[0.4,0.6]"},
            {"start": 0.6, "end": 0.8, "name":"[0.6,0.8]"},
            {"start": 0.8, "end": 1, "name":"[0.8,1]"},
        ];
        for(let i = 0; i<Confidence_list.length; i++){
            Confidence_range_list[i] = total_confidence_range
        }
        let year_name_dict:any = {};
        
        let reversed_name_mapping:any = {}
        year_list.forEach((d:any, index:any)=>{
            let avg_conf = calculate_mean_of_array(Confidence_list[index]);
            let new_key = "" + d + " Average Confidence: "+avg_conf.toFixed(2);
            year_name_dict[d] = new_key
            reversed_name_mapping[new_key] = d;
        })
        let get_year_name = (year:any) => {
            return year_name_dict[year];
        }
        for(let i = 0; i<series_data.length;i++){
            let data_json = series_data[i];
            for(let j = 0; j<year_list.length; j++){
                let local_year = year_list[j];
                let year_name = get_year_name(local_year)
                data_json[local_year] = getContinuousVariableCategory(data_json[local_year], Confidence_range_list[j]);
                data_json[year_name] = data_json[local_year];
            }
        }

        let dimension_names:any = year_list.map((d:any)=>{
            return get_year_name(d);
        })
        console.log("series_data", series_data, Confidence_list, Confidence_range_list)
        if(axis_spec.length > 0 && series_data.length > 0){
            return {
                "PSDimensions": dimension_names,
                "ReversedDimMapping": reversed_name_mapping,
                "PSJson": {
                    "PSData": series_data, 
                    "name": ps_name
                }
            }
        }else{
            return {};
        }
    }else{
        return {};
    }
}
function filtered_data(filters:any, PSJson:any, searched_input:string=""){
    let data = PSJson.PSData.slice();
    let filterData:any[] = [];
    
    let filters_key = Object.keys(filters);
    const selected = (d:any)=>{
        if(filters_key.length>0){
            for(let i = 0; i< filters_key.length;i ++){
                if(filters[filters_key[i]].indexOf(d[filters_key[i]])<0){
                    return false;
                }
            }
            return true;
        }else{
            return true;
        }
    }
    const searched_matched = (d:any) => {
        if(searched_input!==""){
            let gt = d["true_label"];
            if(gt.includes(searched_input)){
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }
    }
    data.forEach((d:any,index:number)=>{
        if(selected(d) && searched_matched(d)){
            let dataInstance = d;
            filterData.push(dataInstance);
        }
    })
    return filterData;
}
function confidence_style(confidence:any, name:any, decimal:number=4){
    //let arr1 = machine_cons.split("/");
    //let corr1 = parseInt(arr1[0]);
    //let total1 = parseInt(arr1[1]);
    let percentage = confidence * 100;
    if(percentage<0){
        percentage = 0;
    }
    if(percentage>100){
        percentage = 100;
    }
    let default_color = "#0f8CFF";
    /*return [<Col span={8}>{name}</Col>,<Col span={16}><Progress percent={percentage} size="small" format={()=>confidence.toFixed(4)}
    style={{"width":"50%"}} strokeColor={{
        '0%': default_color,
        '100%': default_color,
      }} // 80px
     /></Col>]*/

     return <Progress percent={percentage} size="small" format={()=>name+" ("+confidence.toFixed(decimal)+")"}
    style={{"width":"30%"}} strokeColor={{
        '0%': default_color,
        '100%': default_color,
      }} />
     /**
      * strokeColor={{
        '0%': color,
        '100%': color,
      }}
      */
}
function extract_rawdata_for_imagedisplay(ps_json:any, selected_dataset_name:any, filters:any={}, search_input:string=""){
    // filters is dummy now.
    // rawdata_list
    let decimal = getDecimal();
    let ps_package_spec = [{
        "n":"PSJson",
        "c":[{
            "n":"PSData"
        },{
            "n":"name"
        }]
    },{
        "n":"PSDimensions"
    },{"n":"ReversedDimMapping"}]
    let flag = assert_key_hier(ps_json, ps_package_spec);
    if(!flag){
        return [];
    }
    let PSData = ps_json["PSJson"]["PSData"];
    PSData = filtered_data(filters, ps_json["PSJson"], search_input);
    let PSDimensions_old = ps_json["PSDimensions"];
    let ReversedDimMapping = ps_json["ReversedDimMapping"];
    let PSDimensions = PSDimensions_old.map((d:any)=>{
        return ReversedDimMapping[d];
    })
    let rawdata_list = [];
    console.log("PSData, ",PSData);
    for(let i = 0; i<PSData.length; i++){
        let item = PSData[i];
        let text_list = [];
        text_list.push("Ground Truth: "+item["true_label"]);
        for(let j = 0; j<PSDimensions.length; j++){
            let specific_year = PSDimensions[j];
            let confidence = parseFloat(item["Number_"+specific_year]).toFixed(decimal);
            text_list.push(""+specific_year+" Confidence: "+confidence);
            text_list.push(""+specific_year+" Predicted Label:");
            for(let k = 0; k<item["predicted_label_list_"+specific_year].length; k++){
                let local_item = item["predicted_label_list_"+specific_year][k];
                text_list.push(confidence_style(local_item["confidence"], local_item["transcription"], decimal) );
                //text_list.push(""+local_item["transcription"]+" : "+local_item["confidence"].toFixed(4));
            }
        }        
        let alt = item["image_name"];

        let src = getRawDataURL(selected_dataset_name, item["image_name"]);
        rawdata_list.push({
            "src": src,
            "alt": alt,
            "text_list": text_list,
            
        })
    }
    return rawdata_list;

}

export {extract_dataset_list,
    extract_api_list,
    extract_task_list,
    extract_explore_dataset_list,
    extract_value_from_data,
    extract_fairness_from_data,
    convert_package_to_graph,
    extract_ps_data_from_package,
    extract_rawdata_for_imagedisplay
}